export const convertHtmlToFormattedText = (html: string): string => {
  // The HTML comes from the ATS. A DOMParser document is inert, so inline
  // handlers such as <img onerror> do not run, unlike innerHTML on the page.
  const tmpDiv = new DOMParser().parseFromString(html, 'text/html').body;

  // Rich-text editors paste <style> blocks into descriptions; their text is not content.
  tmpDiv
    .querySelectorAll('style, script, template, noscript')
    .forEach((el) => el.remove());

  // Replace common block elements with newlines before extracting text
  const paragraphs = tmpDiv.querySelectorAll(
    'p, div, li, h1, h2, h3, h4, h5, h6'
  );
  paragraphs.forEach((el) => {
    el.insertAdjacentHTML('beforebegin', '\n\n');
  });

  // Replace BR tags with newlines
  const lineBreaks = tmpDiv.querySelectorAll('br');
  lineBreaks.forEach((el) => {
    el.insertAdjacentHTML('afterend', '\n');
  });

  // Get the text content with preserved newlines
  const description = tmpDiv.textContent?.trim() || '';

  // Normalize multiple consecutive newlines to max two
  return description.replace(/\n{3,}/g, '\n\n');
};
